import { styled, Box, TextField } from "@mui/material";

export const FloatingDivContainer = styled(Box)({
  position: "absolute",
  zIndex: 100,
  top: -10000,
  left: -10000,
  marginTop: -6,
  maxWidth: 300,
  width: "100%",
  opacity: 0,
  display: "flex",
  backgroundColor: "#fff",
  boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.3)",
  borderRadius: 8,
  transition: "opacity 0.5s",
});

export const FloatingDivLinkInput = styled(TextField)({
  display: "block",
  paddingRight: 20,
  boxSizing: "border-box",
  width: "100%",
  height: "70%",
  borderRadius: 15,
  margin: "8px 12px",
  fontSize: 15,
  color: "rgb(5, 5, 5)",

  border: 0,
  outline: 0,
  position: "relative",
  fontFamily: "inherit",
  "& .MuiInputBase-root": {
    height: "36px",
    borderRadius: 10,
  },

  "& .MuiInputBase-input": {
    padding: "8px 12px",
    fontSize: "14px",
    lineHeight: "1.2",
  },
});

export const FloatingDivLink = styled("div")({
  display: "block",
  width: "calc(100% - 24px)",
  boxSizing: "border-box",
  margin: "8px 12px",
  padding: "8px 12px",
  wordBreak: "break-all",
  fontSize: 15,
  color: "#1194da",
  border: 0,
  outline: 0,
  position: "relative",
  fontFamily: "inherit",
  textOverflow: "ellipsis",
});
